import Navbar from "../components/lib/Navbar/Navbar";
import Layout from "../components/lib/Layout/Layout";
import AuthForm from "../components/Auth/AuthForm";

function SignIn() {
  return (
    <div className="theme-admin bg-blue-100">
      <Layout>
        <Navbar />
        <AuthForm />
      </Layout>
    </div>
  );
}

export default SignIn;
